import * as taskName from './task-name'

import { createUIDefinition } from '../default-task-definition'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'


export default createUIDefinition({
    taskName: taskName.SHIP_SURGICAL_GUIDE,
    widgetList: [
        {
            component: processUI.DELIVERY_TRACKING_WIDGET,
            widgetProps: {
                showAlignerNumberCounted: true,
            },
        },
        {
            component: processUI.SHIPMENT_LIST_WIDGET_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        if (eventName !== 'surgical_guide_shipped') {
            return null
        }

        return []
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-treatment/ship-surgical-guide.js